import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { ServiceEventNames, ServiceActionTypes, HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import { useFormContext, useWatch } from "react-hook-form";
import EahsForm from "../../../../components/EahsForm";
import FormSelect from "../../../../components/FormInputs/FormSelect";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";
import FormDateInput from "../../../../components/FormInputs/FormDateInput";
import { eformInput } from "../../../../common/cssclasses";

const HorseLeasingHorseSection = ({
    ownerHorsesDropDownData,
    isReadOnly,
    onHorseChange
}) => {
    const { translate } = useTranslate();
    const { control } = useFormContext();
    const horseId = useWatch({ control, name: LeaseFieldNames.HORSE_ID });
    const horseGender = useWatch({ control, name: LeaseFieldNames.HORSE_GENDER });

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.HORSE, "Horse")}>
            <div className="row">
                <FormSelect
                    name={LeaseFieldNames.HORSE_ID}
                    label={translate(TranslationKeys.HORSE, "Horse")}
                    options={[{ label: translate(TranslationKeys.HORSE, "Horse"), value: "" }, ...(ownerHorsesDropDownData || []).map(a => ({ label: `${a.registerNumber} - ${a.name}`, value: a.id }))]}
                    onChangeCallback={onHorseChange}
                    placeholder={translate(TranslationKeys.HORSE, "Horse")}
                    disabled={isReadOnly}
                    required
                    containerClass={eformInput}
                />


                <>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.ORIGIN, "Origin")} name={LeaseFieldNames.HORSE_ORIGIN} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.BREEDER, "Breeder")} name={LeaseFieldNames.HORSE_BREEDER} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.GENDER, "Gender")} name={LeaseFieldNames.HORSE_GENDER_DISPLAY} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.COLOR, "Color")} name={LeaseFieldNames.HORSE_COLOR} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.BIRTH_DATE, "Birth Date")} name={LeaseFieldNames.HORSE_BIRTH_DATE} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.SIRE, "Sire")} name={LeaseFieldNames.HORSE_SIRE} disabled />
                    </div>
                    <div className={eformInput}>
                        <FormTextInput label={translate(TranslationKeys.DAM, "Dam")} name={LeaseFieldNames.HORSE_DAM} disabled />
                    </div>
                </>
            </div>
        </EahsForm>
    );
};

export default HorseLeasingHorseSection;
